const theme = {
  token: {
    fontFamily: "Montserrat",
  },
};

export default theme;
